/* eslint-disable no-console */
/* eslint-disable prettier/prettier */
import { Fragment, FormEvent } from "react";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { useDispatch, useSelector } from "react-redux";

import { notifications } from "../notifications";
import { addNotification, changeEngagementPhase } from "../store/actions/genericActions";
import { ACTION_UPDATE_CONVERSATION_STATE } from "../store/actions/actionTypes";
import { sessionDataHandler } from "../sessionDataHandler";
import { EngagementPhase, AppState } from "../store/definitions";
import { containerStyles,  titleStyles, buttonOkStyles, buttonNotOkStyles, boxButtons } from "./styles/ConversationUserEnded.styles";
import type { Transcript } from "./Transcript";

export const ConversationUserEnded = () => {
    const dispatch = useDispatch();
    const { messages, users, preEngagementData, transcriptConfig, token, conversationSid } = useSelector((state: AppState) => ({
        messages: state.chat.messages,
        users: state.chat.users,
        preEngagementData: state.chat.conversation?.attributes.pre_engagement_data,
        transcriptConfig: state.config.transcript,
        token: state.session.token,
        conversationSid:state.session.conversationSid
    }));

    
    const handleContinueChat = () => {
        dispatch(changeEngagementPhase({ phase: EngagementPhase.MessagingCanvas }));
    }
    const handleConfirmEndChat = async (e: FormEvent) => {
        e.preventDefault();
        dispatch(changeEngagementPhase({ phase: EngagementPhase.Loading }));
        try {
            const data = await sessionDataHandler.fetchAndCloseSession({
                formData: {
                    conversationSid,
                    token 
                }
            });
            
            dispatch({
                type: ACTION_UPDATE_CONVERSATION_STATE,
                payload: { conversationState: data }
                })
            dispatch(changeEngagementPhase({ phase: EngagementPhase.MessagingCanvas }));
        } catch (err) {
            dispatch(addNotification(notifications.failedToInitSessionNotification((err as Error).message)));
            
            dispatch(changeEngagementPhase({ phase: EngagementPhase.MessagingCanvas }));
        }
    }
    let TranscriptComponent: typeof Transcript | undefined = undefined;

    // This file and its related dependencies are only bundled if transcripts are enabled in .env file
    if (process.env.DOWNLOAD_TRANSCRIPT_ENABLED === "true" || process.env.EMAIL_TRANSCRIPT_ENABLED === "true") {
        // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires,global-require
        ({ Transcript: TranscriptComponent } = require("./Transcript"));
    }

    return (
        <Box {...containerStyles}>
            <Text as="span" {...titleStyles} >
                Voulez-vous mettre fin à votre conversation avec un conseiller <br />Libéron ?
            </Text>
            {TranscriptComponent ? (
                <TranscriptComponent
                    messages={messages}
                    preEngagementData={preEngagementData}
                    users={users}
                    transcriptConfig={transcriptConfig}
                />
            ) : (
                <Fragment />
            )}
            
            <Box {...boxButtons}>
                <Box as="button" data-test="resume-chat-button" onClick={handleContinueChat} {...buttonOkStyles}>
                    Annuler
                </Box>
                <Box as="button" data-test="end-current-chat-button" onClick={handleConfirmEndChat} {...buttonNotOkStyles}>
                    Terminer la conversation
                </Box> 
            </Box>
           
        </Box>
    );
};
